export default class VideoConsultationSettings {
  enabled: boolean;
  platform: VideoConsultationPlatform;
  daily?: DailyVideoConsultationSettings;
  custom?: CustomVideoConsultationSettings;
}

export class DailyVideoConsultationSettings {
  roomUrl: string;
  meetingToken: string;
}

export class CustomVideoConsultationSettings {
  roomUrl?: string;
  homeUrl?: string;
}

export enum VideoConsultationPlatform {
  DAILY = "DAILY",
  CUSTOM = "CUSTOM",
}
